/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52356.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class InboxRulesetControllerApi extends runtime.BaseAPI {
    /**
     * Create a new inbox rule for forwarding, blocking, and allowing emails when sending and receiving
     * Create an inbox ruleset
     */
    async createNewInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.createInboxRulesetOptions === null || requestParameters.createInboxRulesetOptions === undefined) {
            throw new runtime.RequiredError('createInboxRulesetOptions', 'Required parameter requestParameters.createInboxRulesetOptions was null or undefined when calling createNewInboxRuleset.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createInboxRulesetOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new inbox rule for forwarding, blocking, and allowing emails when sending and receiving
     * Create an inbox ruleset
     */
    async createNewInboxRuleset(requestParameters, initOverrides) {
        const response = await this.createNewInboxRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete inbox ruleset
     * Delete an inbox ruleset
     */
    async deleteInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteInboxRuleset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete inbox ruleset
     * Delete an inbox ruleset
     */
    async deleteInboxRuleset(requestParameters, initOverrides) {
        await this.deleteInboxRulesetRaw(requestParameters, initOverrides);
    }
    /**
     * Delete inbox rulesets. Accepts optional inboxId filter.
     * Delete inbox rulesets
     */
    async deleteInboxRulesetsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete inbox rulesets. Accepts optional inboxId filter.
     * Delete inbox rulesets
     */
    async deleteInboxRulesets(requestParameters = {}, initOverrides) {
        await this.deleteInboxRulesetsRaw(requestParameters, initOverrides);
    }
    /**
     * Get inbox ruleset
     * Get an inbox ruleset
     */
    async getInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getInboxRuleset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get inbox ruleset
     * Get an inbox ruleset
     */
    async getInboxRuleset(requestParameters, initOverrides) {
        const response = await this.getInboxRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all rulesets attached to an inbox
     * List inbox rulesets
     */
    async getInboxRulesetsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List all rulesets attached to an inbox
     * List inbox rulesets
     */
    async getInboxRulesets(requestParameters = {}, initOverrides) {
        const response = await this.getInboxRulesetsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Test an inbox ruleset
     * Test an inbox ruleset
     */
    async testInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling testInboxRuleset.');
        }
        if (requestParameters.inboxRulesetTestOptions === null || requestParameters.inboxRulesetTestOptions === undefined) {
            throw new runtime.RequiredError('inboxRulesetTestOptions', 'Required parameter requestParameters.inboxRulesetTestOptions was null or undefined when calling testInboxRuleset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets/{id}/test`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.inboxRulesetTestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test an inbox ruleset
     * Test an inbox ruleset
     */
    async testInboxRuleset(requestParameters, initOverrides) {
        const response = await this.testInboxRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Test whether inbound emails from an email address would be blocked or allowed by inbox rulesets
     * Test receiving with inbox rulesets
     */
    async testInboxRulesetReceivingRaw(requestParameters, initOverrides) {
        if (requestParameters.testInboxRulesetReceivingOptions === null || requestParameters.testInboxRulesetReceivingOptions === undefined) {
            throw new runtime.RequiredError('testInboxRulesetReceivingOptions', 'Required parameter requestParameters.testInboxRulesetReceivingOptions was null or undefined when calling testInboxRulesetReceiving.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets/test-receiving`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.testInboxRulesetReceivingOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test whether inbound emails from an email address would be blocked or allowed by inbox rulesets
     * Test receiving with inbox rulesets
     */
    async testInboxRulesetReceiving(requestParameters, initOverrides) {
        const response = await this.testInboxRulesetReceivingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Test whether outbound emails to an email address would be blocked or allowed by inbox rulesets
     * Test sending with inbox rulesets
     */
    async testInboxRulesetSendingRaw(requestParameters, initOverrides) {
        if (requestParameters.testInboxRulesetSendingOptions === null || requestParameters.testInboxRulesetSendingOptions === undefined) {
            throw new runtime.RequiredError('testInboxRulesetSendingOptions', 'Required parameter requestParameters.testInboxRulesetSendingOptions was null or undefined when calling testInboxRulesetSending.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets/test-sending`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.testInboxRulesetSendingOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test whether outbound emails to an email address would be blocked or allowed by inbox rulesets
     * Test sending with inbox rulesets
     */
    async testInboxRulesetSending(requestParameters, initOverrides) {
        const response = await this.testInboxRulesetSendingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Test inbox rulesets for inbox
     * Test inbox rulesets for inbox
     */
    async testInboxRulesetsForInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling testInboxRulesetsForInbox.');
        }
        if (requestParameters.inboxRulesetTestOptions === null || requestParameters.inboxRulesetTestOptions === undefined) {
            throw new runtime.RequiredError('inboxRulesetTestOptions', 'Required parameter requestParameters.inboxRulesetTestOptions was null or undefined when calling testInboxRulesetsForInbox.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.inboxRulesetTestOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test inbox rulesets for inbox
     * Test inbox rulesets for inbox
     */
    async testInboxRulesetsForInbox(requestParameters, initOverrides) {
        const response = await this.testInboxRulesetsForInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Test new inbox ruleset
     * Test new inbox ruleset
     */
    async testNewInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.testNewInboxRulesetOptions === null || requestParameters.testNewInboxRulesetOptions === undefined) {
            throw new runtime.RequiredError('testNewInboxRulesetOptions', 'Required parameter requestParameters.testNewInboxRulesetOptions was null or undefined when calling testNewInboxRuleset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/rulesets`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.testNewInboxRulesetOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test new inbox ruleset
     * Test new inbox ruleset
     */
    async testNewInboxRuleset(requestParameters, initOverrides) {
        const response = await this.testNewInboxRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetInboxRulesetsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
